'use strict';

angular.module('substoreApp.services')
    .factory('uiservice', ['$resource', 'sessionData', function ($resource, sessionData) {
        return $resource('../../uiservice/:methodName?t=:cacheSlayer',
            {
                cacheSlayer: function () {
                    return (new Date().getTime() + Math.random()).toString(16);
                }
            },
            {
                createSession: {
                    method: 'POST',
                    params: {methodName: 'createSession'}
                },
                getSession: {method: 'GET', params: {methodName: 'getSession'}},
                catalogueDialogData: {
                    method: 'GET',
                    params: {methodName: 'catalogueDialogData'}
                },
                deleteSession: {
                    method: 'POST',
                    params: {methodName: 'deleteSession'}
                },
                productDetailsDialogData: {
                    method: 'GET',
                    params: {methodName: 'productDetailsDialogData'}
                },
                orderSelectionDialogData: {
                    method: 'GET',
                    params: {methodName: 'orderSelectionDialogData'}
                },
                subscriptionBegin: {
                    method: 'POST',
                    params: {methodName: 'subscriptionBegin'}
                },
                orderSummaryDialogData: {
                    method: 'GET',
                    params: {methodName: 'orderSummaryDialogData'}
                },
                forgetAuthentication: {
                    method: 'POST',
                    params: {methodName: 'forgetAuthentication'}
                },
                subscriptionCancel: {
                    method: 'POST',
                    params: {methodName: 'subscriptionCancel'}
                },
                subscriptionBook: {
                    method: 'POST',
                    params: {methodName: 'subscriptionBook'}
                },
                orderConfirmationDialogData: {
                    method: 'GET',
                    params: {methodName: 'orderConfirmationDialogData'}
                },
                reservationConfirmationDialogData: {
                    method: 'GET',
                    params: {methodName: 'reservationConfirmationDialogData'}
                },
                orderFormGeneration: {
                    method: 'GET',
                    params: {methodName: 'orderFormGeneration'}
                },
                myProductsOverviewDialogData: {
                    method: 'GET',
                    params: {methodName: 'myProductsOverviewDialogData'}
                },
                myProductsAction: {
                    method: 'POST',
                    params: {methodName: 'myProductsAction'}
                },
                productChangeSelectionDialogData: {
                    method: 'GET',
                    params: {methodName: 'productChangeSelectionDialogData'}
                },
                productChangeSummaryDialogData: {
                    method: 'GET',
                    params: {methodName: 'productChangeSummaryDialogData'}
                },
                productChangeAction: {
                    method: 'POST',
                    params: {methodName: 'productChangeAction'}
                },
                productChangeConfirmationDialogData: {
                    method: 'GET',
                    params: {methodName: 'productChangeConfirmationDialogData'}
                },
                orderAdministrationDialogData: {
                    method: 'GET',
                    params: {methodName: 'orderAdministrationDialogData'}
                },
                orderAdministrationSummaryDialogData: {
                    method: 'GET',
                    params: {methodName: 'orderAdministrationSummaryDialogData'}
                },
                orderAdministrationAction: {
                    method: 'POST',
                    params: {methodName: 'orderAdministrationAction'}
                },
                orderAdministrationConfirmationDialogData: {
                    method: 'GET',
                    params: {methodName: 'orderAdministrationConfirmationDialogData'}
                },
                getProductAvailability: {
                    method: 'GET',
                    params: {methodName: 'productAvailability'}
                },
                userCreation: {
                    method: 'POST',
                    params: {methodName: 'userCreation'}
                },
                faultMessage: {
                    method: 'GET',
                    params: {methodName: 'faultMessage'}
                },
                productDetailsAction: {
                    method: 'POST',
                    params: {methodName: 'productDetailsAction'}
                },
                i18nMessages: {
                    method: 'GET',
                    params: {methodName: 'i18nMessages'}
                },
                setLanguage: {
                    method: 'GET',
                    params: {methodName: 'setLanguage'}
                }
            }
        );
    }]);